import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Contact, ContactCreateUpdate } from '@lockton-apps/shared/interfaces';
import { Observable, of } from 'rxjs';
import { getDevConfig } from '@lockton-apps/shared/util/helpers';
import { MocksService } from '@lockton-apps/shared/util/mocks';

@Injectable({
  providedIn: 'root',
})
export class ContactsService {
  constructor(
    @Optional() private readonly mocksService: MocksService,
    @Inject('BASE_API_URL') private baseUrl: string,
    private http: HttpClient
  ) {}

  all() {
    return this.http.get<Contact[]>(`${this.baseUrl}/contacts`);
  }

  allForClient(clientId: number) {
    if (getDevConfig('client.fullMock')) {
      return of(this.mocksService.getClientContacts(clientId));
    }

    return this.http.get<Contact[]>(
      `${this.baseUrl}/contacts/client/${clientId}`
    );
  }

  load(userId: string) {
    return this.http.get<Contact>(`${this.baseUrl}/contacts/contact/${userId}`);
  }

  loadForAuthenticatedUser() {
    return this.http.get<Contact>(`${this.baseUrl}/contacts/contact`);
  }

  create(contact: ContactCreateUpdate) {
    return this.http.post<Contact>(`${this.baseUrl}/contacts`, {
      ...contact,
    });
  }

  update(contact: ContactCreateUpdate, userId: string) {
    return this.http.patch<Contact>(
      `${this.baseUrl}/contacts/${userId}`,
      contact
    );
  }

  enable(userId: string) {
    return this.http.put<Contact>(
      `${this.baseUrl}/contacts/enable/${userId}`,
      null
    );
  }

  disable(userId: string) {
    return this.http.put<Contact>(
      `${this.baseUrl}/contacts/disable/${userId}`,
      null
    );
  }

  hasOpenEnquiries(userId: string): Observable<number[]> {
    return this.http.get<number[]>(
      `${this.baseUrl}/users/${userId}/assignedquotes`
    );
  }
}
